/**
 * UserStatusToggle component
 * Radio group for toggling user active/inactive status
 */
import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { cn } from '@/lib/utils'

export interface UserStatusToggleProps {
  /** Whether the user is currently active */
  isActive: boolean
  /** Called when status changes */
  onChange: (isActive: boolean) => void
  /** Whether the toggle is disabled */
  disabled?: boolean
  /** Additional CSS classes */
  className?: string
}

/**
 * Radio group for toggling user active/inactive status
 */
export function UserStatusToggle({
  isActive,
  onChange,
  disabled,
  className,
}: UserStatusToggleProps) {
  return (
    <RadioGroup
      value={isActive ? 'active' : 'inactive'}
      onValueChange={(value) => onChange(value === 'active')}
      disabled={disabled}
      className={cn('flex gap-4', className)}
    >
      <div className="flex items-center space-x-2">
        <RadioGroupItem value="active" id="status-active" disabled={disabled} />
        <Label
          htmlFor="status-active"
          className={cn(
            'cursor-pointer',
            disabled && 'cursor-not-allowed opacity-50'
          )}
        >
          Active
        </Label>
      </div>
      <div className="flex items-center space-x-2">
        <RadioGroupItem value="inactive" id="status-inactive" disabled={disabled} />
        <Label
          htmlFor="status-inactive"
          className={cn(
            'cursor-pointer',
            disabled && 'cursor-not-allowed opacity-50'
          )}
        >
          Inactive
        </Label>
      </div>
    </RadioGroup>
  )
}
